import {SelectButton as PrimeSelectButton} from 'primereact/selectbutton';
import styled from 'styled-components';

export const SelectButton = styled(PrimeSelectButton)`
  .p-highlight {
    background-color: ${({theme}) => theme.color_action};
    pointer-events: none;
  }
`;